<div class="draggable-container" cdkDrag cdkDragBoundary=".modal" cdkDragRootElement="draggable-container">
  <div class="draggable-modal-content cursor-pointer" cdkDragHandle>
<ng-container>
  <div class="modal-header align-items-center" >
    <h6 class="modal-title modal-title-success">
     {{modalTitle|translate}}
    </h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
  </div>

      <div class="modal-body p-0" *ngIf="isLoading; else loadedContentTpl">
        <div class="lms-module-card">
          <div class="card-body">
            <div class="text-center py-5">{{ 'Loading...' | translate }}</div>
          </div>
        </div>
      </div>

      <ng-template #loadedContentTpl>
        <div class="modal-body p-0">
          <div class="lms-module-card">
            <div class="card-body">
              <div class="card-form-content card-form-success">
                <div class="accrual-section">
                  <div class="accrual-section__header">
                    <div>
                      <div class="accrual-section__subtitle" *ngIf="hasValidDates">{{ modalSubTitle | translate }}</div>
                    </div>
                  </div>

                  <div class="field-group mb-0 accrual-date-field" *ngIf="hasValidDates; else noValidDatesTpl">
                    <label class="mb-1 field-required">{{ 'Effective Date' | translate }}</label>
                    <div class="position-relative" style="max-width: 240px;">
                      <input
                        class="form-control form-control-date1 form-control-sm"
                        [(ngModel)]="selectedDate"
                        (ngModelChange)="onDateChange($event)"
                        [minDate]="accrualMinDate"
                        [maxDate]="accrualMaxDate"
                        [startDate]="calendarStartDate"
                        [markDisabled]="markDisabled"
                        [dayTemplate]="accrualDayTpl"
                        [outsideDays]="'visible'"
                        datepickerClass="accrual-datepicker"
                        placeholder="mm/dd/yyyy"
                        (blur)="onDateBlur(dateModel.status || null)"
                        ngbDatepicker
                        #dateModel="ngModel"
                        #dp="ngbDatepicker"
                        name="effective_date"
                        required
                        autocomplete="off"
                        onkeyup="this.value=this.value
                          .replace(/^(\d{2})(\d)$/g,'$1/$2')
                          .replace(/^(\d{2}\/\d{2})(\d+)$/g,'$1/$2')
                          .replace(/[^\d\/]/g,'')"
                      />
                      <button class="btn calendar" (click)="openCalendar(dp)" type="button">
                        <img class="img-invert" src="assets/images/icons/cal-icon.png" alt="" />
                      </button>
                    </div>

                    <div class="font-size-14 text-danger mt-1" *ngIf="showEffectiveDateRequired">
                      {{ 'Please select effective date.' | translate }}
                    </div>

                    <ng-template
                      #accrualDayTpl
                      let-date
                      let-selected="selected"
                      let-disabled="disabled"
                      let-focused="focused"
                      let-currentMonth="currentMonth">
                      <span
                        class="accrual-calendar-day"
                        [class.bg-primary]="selected"
                        [class.text-white]="selected"
                        [class.text-muted]="disabled"
                        [class.accrual-calendar-day--valid]="!disabled && isValidCalendarDate(date)"
                        [class.accrual-calendar-day--outside]="date.month !== currentMonth"
                        [class.focused]="focused"
                        [class.active]="focused">
                        {{ date.day }}
                      </span>
                    </ng-template>

                    <div class="accrual-status-section" *ngIf="!isEditMode">
                      <div class="accrual-section__title">
                        {{ 'Loan Accrual Status (Current)' | translate }}
                      </div>
                      <div class="table-responsive">
                        <table class="table table-sm table-no-bg table-align-middle mb-0 accrual-status-table">
                          <thead>
                            <tr>
                              <td class="border-0">{{ 'Before' | translate }}</td>
                              <td class="border-0"></td>
                              <td class="border-0">{{ 'After' | translate }}</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <span
                                  class="accrual-operation-badge"
                                  [class.accrual-operation-badge--start]="accrualStatusBefore === 'START_INT'"
                                  [class.accrual-operation-badge--stop]="accrualStatusBefore === 'STOP_INT'">
                                  {{ accrualStatusBefore | translate }}
                                </span>
                              </td>
                              <td>
                                <img class="img-fluid icon-dark" src="assets/images/icons/arrow2-transparent.png" alt="" />
                                <img class="img-fluid icon-light" src="assets/images/icons/arrow2-light.png" alt="" />
                              </td>
                              <td>
                                <span
                                  *ngIf="hasSelectedEffectiveDate; else afterPlaceholderTpl"
                                  class="accrual-operation-badge"
                                  [class.accrual-operation-badge--start]="accrualStatusAfter === 'START_INT'"
                                  [class.accrual-operation-badge--stop]="accrualStatusAfter === 'STOP_INT'">
                                  {{ accrualStatusAfter | translate }}
                                </span>
                                <ng-template #afterPlaceholderTpl>
                                  <span
                                    class="accrual-after-placeholder"
                                    [matTooltip]="afterDateTooltip"
                                    matTooltipPosition="above">
                                    -
                                  </span>
                                </ng-template>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <ng-template #noValidDatesTpl>
                    <div class="bg-note-info p-2 accrual-no-dates-msg">
                      {{ noValidDatesMessage }}
                    </div>
                  </ng-template>
                </div>

                <hr class="accrual-divider" />

                <!-- 2. Interest Accrual History -->
                <div class="accrual-section">
                  <div class="accrual-section__header">
                    <div>
                      <div class="accrual-section__title">{{ 'Interest Accrual History' | translate }}</div>
                    </div>
                  </div>

                  <div class="table-responsive accrual-history-table">
                    <table class="table table-sm table-no-bg table-align-middle mb-0">
                      <thead>
                        <tr>
                          <th class="border-0">{{ 'Sr' | translate }}</th>
                          <th class="border-0">{{ 'Effective Date' | translate }}</th>
                          <th class="border-0">{{ 'Payment Info' | translate }}</th>
                          <th class="border-0">{{ 'Payment Status' | translate }}</th>
                          <th class="border-0">{{ 'Transaction Date' | translate }}</th>
                          <th class="border-0">{{ 'Transaction Agent' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="historyList?.length; else emptyHistory">
                          <ng-container *ngFor="let item of historyList; let i = index">
                            <ng-container *ngIf="shouldShowPreviewBefore(i)"
                              [ngTemplateOutlet]="pendingTransactionRow">
                            </ng-container>
                            <tr [class.accrual-editing-row]="isEditingTransaction(item)">
                              <td>
                                {{ i + 1 }}
                              </td>
                              <td>{{ formatDisplayDate(item.payment_effective_date) }}</td>
                              <td>
                                <span
                                  class="accrual-operation-badge"
                                  [class.accrual-operation-badge--start]="item.payment_info_code_slug === 'START_INT'"
                                  [class.accrual-operation-badge--stop]="item.payment_info_code_slug === 'STOP_INT'">
                                  {{ item.payment_info_code_slug | translate }}
                                </span>
                              </td>
                              <td>{{ item.payment_status || '-' }}</td>
                              <td>{{ formatTransactionDate(item.transaction_date) }}</td>
                              <td>{{ item.transaction_agent_full_name || '-' }}</td>
                            </tr>
                          </ng-container>

                          <ng-container *ngIf="showPreviewAtEnd"
                            [ngTemplateOutlet]="pendingTransactionRow">
                          </ng-container>
                        </ng-container>

                        <ng-template #emptyHistory>
                          <ng-container *ngIf="displaySelectedDate"
                            [ngTemplateOutlet]="pendingTransactionRow">
                          </ng-container>
                          <tr *ngIf="!displaySelectedDate">
                            <td colspan="6" class="text-center py-3">
                              {{ 'No interest accrual history found.' | translate }}
                            </td>
                          </tr>
                        </ng-template>
                      </tbody>
                    </table>
                  </div>

                  <ng-template #pendingTransactionRow>
                      <tr class="accrual-preview-message-row">
                        <td colspan="6">
                          <div class="accrual-preview-message">
                            <strong>{{ operationType | translate }}</strong>
                            {{ previewMessage }}
                            <strong>{{ displaySelectedDate }}</strong>
                          </div>
                        </td>
                      </tr>
                  </ng-template>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer justify-content-between">
          <div></div>
          <div>
            <button
              type="button"
              class="btn btn-success-light btn-150"
              [disabled]="!canSubmit"
              (click)="submit()">
              {{ 'Submit' | translate }}
            </button>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>
